import http from 'lib/utils/axios';
// import serializeParams from 'lib/utils/url';

const REPORT_URL = '/report/';

//export const fetchList = type => http.get(`${REPORT_URL}templates/?type=${type}`);
// export const fetchLink = data => http.get(`${REPORT_URL}?${serializeParams(data)}`);
export const fetchReportFeilds = type => http.get(`/report-fields?type=${type}`);
export const fetchTemplateById = id => http.get(`${REPORT_URL}template/${id}`);
export const createTemplate = data => http.post(`${REPORT_URL}template`, data);
export const editTemplate = (data, id) => http.put(`${REPORT_URL}template/${id}`, data);
// export const deleteTemplate = id => http.delete(`${REPORT_URL}template/${id}`);
// export const renameTemplate = (id, name) => http.put(`${REPORT_URL}template/${id}/rename`, name);

export default {
  //fetchList,
  // fetchLink,
  fetchReportFeilds,
  fetchTemplateById,
  createTemplate,
  editTemplate,
  // deleteTemplate,
  // renameTemplate,
};
